import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <UpdatesSection />
        <IndexSection />
        <RankingSection />
        <ContactSection />
        <TopicsSection />
        <AppSection />
        <FeaturesSection />
        <FaqSection />
        <CommentsSection />
        <CardsSection />
        <AboutSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}